module.exports = __webpack_public_path__ + "static/media/Piercing-femintimate-Cristina.b134ee2e.png";